export enum MapQueryParamKey {
  ROUTE_CALCULATOR = 'routeCalculator',
  SERVICE = 'service',
  SWAP_PANEL = 'swapPanel',
  VEHICLE_UUID = 'vehicleUuid',
  ORDER_UUID = 'orderUuid',
}
